<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '24',
	},
	height: {
		type: String,
		default: '24',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="apple">
			<path
				id="bg"
				d="M45.25 24C45.25 35.592 35.8525 45 24.25 45C12.6475 45 3.25 35.592 3.25 24C3.25 12.3975 12.6475 3 24.25 3C35.8525 3 45.25 12.3975 45.25 24Z"
				fill="#283544"
			/>
			<path
				id="apple_2"
				d="M34.0932 18.6861C33.9786 18.7529 31.2506 20.1637 31.2506 23.2918C31.3792 26.8591 34.6932 28.1102 34.75 28.1102C34.6932 28.177 34.2497 29.8144 32.936 31.5308C31.8935 33.0093 30.7363 34.5 28.9792 34.5C27.3077 34.5 26.7077 33.5146 24.7792 33.5146C22.708 33.5146 22.122 34.5 20.5363 34.5C18.7792 34.5 17.5363 32.9295 16.4369 31.4648C15.0086 29.5479 13.7947 26.5396 13.7518 23.6512C13.7229 22.1206 14.0378 20.616 14.8372 19.3381C15.9655 17.554 17.9798 16.3429 20.1795 16.3029C21.8649 16.25 23.3649 17.3812 24.3935 17.3812C25.3792 17.3812 27.222 16.3029 29.3071 16.3029C30.2071 16.3038 32.6071 16.5564 34.0932 18.6861ZM24.2509 15.9973C23.9509 14.5996 24.7792 13.2018 25.5506 12.3102C26.5363 11.2319 28.0932 10.5 29.4357 10.5C29.5214 11.8978 28.9782 13.2686 28.0074 14.267C27.1363 15.3453 25.6363 16.1571 24.2509 15.9973Z"
				fill="white"
			/>
		</g>
	</svg>
</template>
